<template>
	<div class="company-address-card">
		<div class="company-address-card__header" v-if="item.isPrimary">Primary</div>
		<div class="company-address-card__body">
			<div class="company-address-card__label">lorem ipsum</div>
			<div class="company-address-card__text">{{ item.address1 }}</div>
			<div class="company-address-card__text">{{ item.address2 }}</div>
			<div class="company-address-card__text">{{ cityCountyState }}</div>
			<div class="company-address-card__text">{{ item.type }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CompanyAddressCard',
	components: {},
	props: {
		item: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		cityCountyState() {
			return `${this.item.city} ${this.item.county} ${this.item.state} ${this.item.zip}`;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-address-card {
	@include card;
	width: 365px;
	padding: 0;
	overflow: hidden;

	&__header {
		padding: $padding-sm $padding-md;
		@include body-text('regular-emphasis');
		color: $white;
		background-color: $base;
	}

	&__body {
		padding: $padding-sm $padding-md;
		@include body-text('regular');
	}

	&__body > * {
		&:not(:last-child) {
			margin-bottom: $gutter-md;
		}
	}

	&__label {
		@include heading('md');
	}
}
</style>
